module.exports = __webpack_public_path__ + "startpage-be63061f/template-5-2x-bc170faebb43de630703071cc640fa2a.jpg";